import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const AddSupplierModalContent: StyleRule = () => ({
    marginTop: pxToRem(24),
});

export const AddSupplierInput: StyleRule = ({ theme }) => ({
    marginBottom: pxToRem(24),
    borderBottom: `1px solid ${theme.siteVariables.colors.charcoal[250]}`,
    height: pxToRem(74),
});
